import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";

type Props = Readonly<{
	open: boolean;
	handleConfirmClick: () => void;
	handleClose: () => void;
}>;

const WarningDialog = ({ open, handleConfirmClick, handleClose }: Props) => {
	const { t } = useTranslation();
	return (
		<Dialog
			fullWidth={true}
			open={open}
			onClose={handleClose}
		>
			<DialogTitle>{t("teditor.warningTitle")}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{t("teditor.warningMsg")}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleConfirmClick} style={{ marginRight: 5 }}>{t("dialog.confirm")}</Button>
				<Button color="inherit" onClick={handleClose}>{t("dialog.cancel")}</Button>
			</DialogActions>
		</Dialog>
	);
};

export default WarningDialog;
